import ExtensionCapability from '../../capability';
import type Instance from '../../instance';
import { Specs } from '@doxyme/extensions-common';

type Constraints = Specs.PingPong.Constraints;
type PingPayload = Specs.PingPong.PingPayload;

const { PingPong } = Specs;

/**
 * Ping Pong is used to demo the connection between the host application and the extension by sending events and receiving actions back. This capability is used heavily in tests.
 */
export default class PingPongCapability extends ExtensionCapability<Constraints> {
  static readonly id = PingPong.id;

  constructor() {
    super(PingPong);

    this.handlers.push(
      [PingPong.Actions.Pong, this.receivePong.bind(this)],
      [PingPong.Actions.Sing, this.sing.bind(this)],
    );
  }

  private sing(payload: PingPayload, instance: Instance<Constraints>): void {
    const pingPayload = { ...payload, pongTime: new Date().toISOString() };

    instance.notify([PingPong.Events.Song, pingPayload]);

    console.info(`PING PONG SINGED ${JSON.stringify(pingPayload)}`);
  }

  private receivePong(payload: PingPayload): void {
    console.info(`PING-PONG PONGED: ${JSON.stringify(payload)}`);
  }

  /**
   * Ping the extensions with the current time
   * @param pingTime - The ping time
   * @example
   * ```ts
   * pingPong.ping();
   * ```
   */
  ping(pingTime: Date = new Date()): void {
    this.notifyAll([
      PingPong.Events.Ping,
      { pingTime: pingTime.toISOString() },
    ]);
  }
}
